// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__hR2oV","buttons":"PendingPaymentAlert_buttons__iOore"};